import { render, staticRenderFns } from "./PaymentBeforeTelehealth.vue?vue&type=template&id=4b84ce54&scoped=true"
import script from "./PaymentBeforeTelehealth.vue?vue&type=script&lang=js"
export * from "./PaymentBeforeTelehealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b84ce54",
  null
  
)

export default component.exports